<template>
    <footer>
        <div class="icon">
            <i class="fal fa-volume-up" aria-hidden="true"
            v-if="music.play" @click="musicMute()"></i>
            <i class="fal fa-volume-mute" aria-hidden="true"
            v-else @click="musicPlay()"></i>
        </div>
        <div class="icon">
            <i class="fal fa-music" aria-hidden="true"></i>
        </div>
        <div class="icon">
            <i class="fal fa-info-circle" aria-hidden="true"
            @click="propModal({name: 'infoModal', bol:true})"></i>
        </div>
    </footer>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
    computed: {
        ...mapGetters([
            "music",
        ]),
    },

    methods: {
        ...mapActions([
            "musicPlay",
            "musicMute",
            "propModal"
        ])
    }
}
</script>

<style lang="scss" scoped>
footer {
    height: 60px;
    display: flex;
    justify-content: center;

    .icon {
        width: 50px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin: 0 15px;
        color: white;
        font-size: 28px;
        
        i {
            cursor: pointer;
        }
    }
}


@media(max-width: 540px) {
    footer {
        .icon {
            align-items: center;
            font-size: 20px;
            margin: 0 5px;
        }
    }
}
</style>